// client/src/components/agent/actions/PayLinkView.jsx
import { useState, useEffect } from 'react';
import theme from '../../../theme';

export default function PayLinkView({ token, conv, onBack }) {
  const [valor, setValor] = useState('');
  const [orders, setOrders] = useState([]);
  const [billId, setBillId] = useState('');
  const [body, setBody] = useState('');
  const [buttonName, setButtonName] = useState('');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');
  const c = theme.colors;
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  const inputStyle = { width: '100%', padding: '6px 8px', background: c.background, color: c.text, border: `1px solid ${c.border}`, borderRadius: 6, marginBottom: 8, boxSizing: 'border-box', fontSize: 13 };

  useEffect(() => {
    fetch('/api/agent/orders/payable', { headers }).then((r) => r.json()).then(setOrders).catch(() => {});
    setValor(''); setBillId(''); setBody(''); setButtonName(''); setMsg('');
  }, [conv?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const send = async () => {
    if (!conv || !valor || !body.trim() || !buttonName.trim()) { setMsg('Completa los campos'); return; }
    setSending(true); setMsg('');
    try {
      const r = await fetch('/api/agent/paylink', {
        method: 'POST', headers,
        body: JSON.stringify({ valor: Number(valor), bill_id: billId || null, body, button_name: buttonName, conversation_id: conv.id }),
      });
      const data = await r.json();
      setMsg(r.ok ? 'Link enviado ✓' : (data.message || 'Error'));
    } catch { setMsg('Error de red'); }
    setSending(false);
  };

  return (
    <div style={{ padding: 12, color: c.text, overflowY: 'auto' }}>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: c.primary, cursor: 'pointer', marginBottom: 8 }}>← Atrás</button>
      <h4 style={{ margin: '4px 0 10px' }}>Generar link de pago</h4>

      <input style={inputStyle} type="number" onWheel={(e) => e.currentTarget.blur()} placeholder="Valor" value={valor} onChange={(e) => setValor(e.target.value)} />
      <select style={inputStyle} value={billId} onChange={(e) => setBillId(e.target.value)}>
        <option value="">No asociar a ningún pedido</option>
        {orders.map((o) => <option key={o.id} value={o.id}>#{o.id} — ${Number(o.total).toLocaleString('es-CO')} {o.customer_name || ''}</option>)}
      </select>
      <textarea style={{ ...inputStyle, minHeight: 60 }} placeholder="Mensaje (body)" value={body} onChange={(e) => setBody(e.target.value)} />
      <input style={inputStyle} placeholder="Nombre del botón (máx 20)" maxLength={20} value={buttonName} onChange={(e) => setButtonName(e.target.value)} />
      <div style={{ fontSize: 11, color: c.textMuted, marginBottom: 8 }}>{buttonName.length}/20</div>

      <button onClick={send} disabled={sending} style={{ width: '100%', background: c.primary, color: '#001018', border: 'none', borderRadius: 6, padding: '8px', cursor: 'pointer', opacity: sending ? 0.6 : 1 }}>
        {sending ? 'Enviando…' : 'Enviar'}
      </button>
      {msg && <div style={{ marginTop: 8, fontSize: 13, color: msg.includes('✓') ? c.success : c.error }}>{msg}</div>}
    </div>
  );
}
